<template>
  <div class="c-langs-group">
    <the-button
      v-for="(lang, i) in langs"
      :key="i" :link="lang.link"
      :cssClass="'c-langs-group__button'"
    >
      {{ lang.name }}
    </the-button>
  </div>
</template>

<script>
import TheButton from '@/components/TheButton.vue';

export default {
  name: 'TheLangPicker',

  // props: {
  //   langs: Object,
  // },

  data() {
    return {
    langs: [{
      name: 'Norsk bokmål',
      link: 'nor-NO'
    },
    {
      name: 'Norsk nynorsk',
      link: 'nno-NO'
    },
    {
      name: 'Engelsk – English',
      link: 'eng-GB'
    },
    {
      name: 'Arabisk – العربية',
      link: 'ara-SA'
    },
    {
      name: 'Dari – دری',
      link: 'prs-AF'
    },
        {
      name: 'Kurmanji – Kurmancî',
      link: 'ku-TR'
    },
    {
      name: 'Pashto – پښتو',
      link: 'ps-AF'
    },
    {
      name: 'Tigrinja – ትግርኛ',
      link: 'ti-ER'
    }]
    }

  },

  // computed: {
  //   sortedLangs () {
  //     const arr = this.langs.language_codes;
  //     const langToMove = [
  //       {name: 'eng-GB', newPos: 2},
  //       {name: 'nno-NO', newPos: 1},
  //       {name: 'nor-NO', newPos: 0}
  //     ];

  //     langToMove.forEach(lang => {
  //       const fromIndex = arr.indexOf(lang.name);
  //       const element = arr[fromIndex];
    
  //       arr.splice(fromIndex, 1);
  //       arr.splice(lang.newPos, 0, element);
  //     })

  //     return arr;
  //   }
  // },

  components: {
    TheButton,
  }
};
</script>

<style>
.c-langs-group {
  display: flex;
  flex-direction: column;
}

.c-langs-group button {
  color: #fff;
}

.c-langs-group__button {
  background: #2e2d84;
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px;
  letter-spacing: 1.2px;
  margin-top: 10px;
  text-align: center;
}

.c-langs-group__button:first-child {
  margin-top: 0;
}
</style>
